export const Tray = () => {
    return (
        <svg aria-hidden="true" viewBox="0 0 48 48" fill="currentColor">
            <path d="M31 21L17 21L17 17L31 17V21Z" />
            <path
                fillRule="evenodd"
                d="M10 10V38H38V10H10ZM34 14H14V24H18C18 27.3137 20.6863 30 24 30C27.3137 30 30 27.3137 30 24H34V14Z"
            />
        </svg>
    );
};
